import { render, staticRenderFns } from "./InvoicesTab.vue?vue&type=template&id=238f6143&scoped=true"
import script from "./InvoicesTab.vue?vue&type=script&lang=js"
export * from "./InvoicesTab.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTab.vue?vue&type=style&index=0&id=238f6143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f6143",
  null
  
)

export default component.exports